import shared from "./base.module";
import { user as userApi } from "../../../api/user.api";
import defaultUser, { dailyDataUserRoles } from "@lab/meta/user";
import { HospitalUser } from "@lab/types/users";

const state = {
	...shared.state,
	user: { ...defaultUser, role: "dailydata-general" }
};

const getters = {
	...shared.getters,
	roles: (_) => dailyDataUserRoles,
	user: (state, getters) => {
		return {
			...state.user,
			dashboards: state.dashboards
		} as HospitalUser;
	}
};

const actions = {
	...shared.actions,
	async prepare({ commit }, user) {
		const { id } = user;
		commit("SET_USER", user);
		const dashboards = await userApi.dashboards.get(id);
		commit("SET_DASHBOARDS", dashboards || []);
	}
};

const mutations = {
	...shared.mutations
};

export default { namespaced: true, state, getters, actions, mutations };
